if (!customElements.get('scrolling-banner')) {
  const ScrollingBanner = class extends HTMLElement {
    constructor() {
      super();
      this.visibleVideos = new Set();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // Transforms can confuse lazy loading in browsers, so we coordinate loading here
      // Load all countdown timers
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init());
      });

      // Load all images
      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager';
      });

      this.initVideos();

      // After fonts have loaded
      document.fonts.ready.then(() => this.querySelector('.marquee').classList.add('marquee--animate'));
    }

    initVideos() {
      const videos = this.querySelectorAll('.js-scrolling-banner-video');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = navigator.connection && navigator.connection.saveData;

      if (!videos.length || reduceMotion || saveData || !('IntersectionObserver' in window)) return;

      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            this.visibleVideos.add(video);
            this.loadVideo(video);
            if (!document.hidden) video.play().catch(() => {});
          } else {
            this.visibleVideos.delete(video);
            video.pause();
          }
        });
      }, {
        rootMargin: '0px 240px',
        threshold: 0.01
      });

      videos.forEach((video) => this.videoObserver.observe(video));

      this.onVisibilityChange = () => {
        if (document.hidden) {
          videos.forEach((video) => video.pause());
        } else {
          this.visibleVideos.forEach((video) => video.play().catch(() => {}));
        }
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    loadVideo(video) {
      if (video.dataset.loaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.muted = true;
      video.defaultMuted = true;
      video.dataset.loaded = 'true';
      video.load();
    }

    disconnectedCallback() {
      this.videoObserver?.disconnect();
      if (this.onVisibilityChange) {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }
    }
  };

  window.customElements.define('scrolling-banner', ScrollingBanner);
}
